import React from "react";
import Widget from "../../components/Widget/Widget";
import PaymentNotice from "./components/InvoicesComponents/PaymentNotice";
import PaymentNoticeSolar from "./components/InvoicesComponents/PaymentNoticeSolar";
import { useState } from "react";
import Select from "react-select";
import styles from "./Invoice.module.scss";
import ProfitSharingNotice from "./components/InvoicesComponents/ProfitSharingNotice";
import TotalSettlement from "./components/InvoicesComponents/TotalSettlement";

function Invoices() {
  const [noticeType, setNoticeType] = useState({
    value: "Profit Share",
    label: "Profit Share",
  });

  const noticeTypeOptions = [
    {
      value: "Payment Notice",
      label: "Payment Notice",
    },
    {
      value: "Payment Notice (Solar)",
      label: "Payment Notice (Solar)",
    },
    {
      value: "Profit Share",
      label: "Profit Share",
    },
    {
      value: "Total Settlement",
      label: "Total Settlement",
    },
  ];
  return (
    <div>
      <div className={styles.MainSelect}>
        <Select
          defaultValue={noticeType}
          options={noticeTypeOptions}
          onChange={setNoticeType}
          classNamePrefix="react-select"
          styles={{
            control: (base) => ({
              ...base,
              backgroundColor: 'var(--input-bg)',
              color: 'var(--body-color)',
              borderColor: 'var(--input-border)'
            }),
            singleValue: (base) => ({ ...base, color: 'var(--body-color)' }),
            menu: (base) => ({ ...base, backgroundColor: 'var(--card-bg)', color: 'var(--body-color)' }),
            option: (base, state) => ({
              ...base,
              backgroundColor: state.isFocused ? 'var(--sidebar-hover-bg)' : 'transparent',
              color: 'var(--body-color)'
            })
          }}
        />
      </div>

      {noticeType.value === "Payment Notice" ? (
        <Widget title="Monthly Payment Notice">
          <PaymentNotice />
        </Widget>
      ) : noticeType.value === "Payment Notice (Solar)" ? (
        <Widget title="Monthly Payment Notice (Solar)">
          <PaymentNoticeSolar />
        </Widget>
      ) : noticeType.value === "Total Settlement" ? (
        <Widget title="Total Settlement">
          <TotalSettlement />
        </Widget>
      ) : (
        <Widget title="Profit Sharing Notice">
          <ProfitSharingNotice />
        </Widget>
      )}
    </div>
  );
}

export default Invoices;